import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { ProductDimensionsImages } from '../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../common/components/CarouselWithModal/CarouselWithModal'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.PRODUCT_DIMENSIONS_PURCHASING_OPTIONS
        }
        question="What do I need to do on this page?"
      />
    ),
    answer: (
      <div>
        You'll define your product's pricing model and plans for AWS
        Marketplace. Each dimension represents a feature, service, or aspect of
        your product that buyers can purchase at a per-unit price. The choices
        you make here will determine how buyers can subscribe to and purchase
        your product.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.PRODUCT_DIMENSIONS_PURCHASING_OPTIONS
        }
        question="I want to charge a fixed contract price but also bill for usage. Which pricing model should I choose?"
      />
    ),
    answer: (
      <div>
        Choose the SaaS contract pricing model and add usage-based dimensions to
        track and charge for additional consumption. Each usage dimension should
        align with the different plans or features where usage is metered.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.PRODUCT_DIMENSIONS_PURCHASING_OPTIONS
        }
        question="What is the purpose of the dimension unit type?"
      />
    ),
    answer: (
      <div>
        <p>
          The unit type defines how buyers are charged based on usage. It
          represents the metric you'll use to track and report consumption to
          AWS for billing. For example, if you charge per user, set the unit
          type as "Users."
        </p>
        <div
          style={{
            backgroundColor: '#eef7f7',
            padding: '10px',
            borderRadius: '4px',
            marginTop: '10px',
          }}
        >
          <p>
            <strong>Key points:</strong>
          </p>
          <p>
            If your unit of measurement might change in the future, we recommend
            selecting "Units" as a generic option. This field cannot be changed
            after your listing is created.
          </p>
        </div>
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.PRODUCT_DIMENSIONS_PURCHASING_OPTIONS
        }
        question="What are purchasing options, and how do they affect my listing?"
      />
    ),
    answer: (
      <div style={{ textAlign: 'justify' }}>
        Purchasing options determine how buyers can select and pay for your
        product. Multiple dimensions per contract: Buyers can purchase multiple
        features or plans at once. Single dimension per contract: Buyers must
        choose only one option from the available dimensions{' '}
        <strong>
          (e.g., different user tiers like 1-100 users vs. 101-200 users).
        </strong>
      </div>
    ),
  },
]

interface FlyoutProductDimensionsPurchasingOptionsFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const FlyoutProductDimensionsPurchasingOptionsFaqs: React.FC<
  FlyoutProductDimensionsPurchasingOptionsFaqsProps
> = ({ indexModal, setIndexModal }) => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Purchasing options"
    faqItems={faqItems}
    customContent={
      <CarouselWithModal
        carouselData={ProductDimensionsImages}
        setCurrentIndex={setIndexModal}
        currentIndex={indexModal}
      />
    }
  />
)
